import React from "react";
import "../styles/Components.css";
import styles from "../styles/modules/AdminPage.module.css";

const RequiredMark: React.FC = () => {
  return <span className={styles["required-mark"]}>*</span>;
};

export default RequiredMark;
